import { render, staticRenderFns } from "./submission-status-badge.vue?vue&type=template&id=a2cb108c"
import script from "./submission-status-badge.vue?vue&type=script&lang=js"
export * from "./submission-status-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports